import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'zipCode'
})
export class ZipCodePipe implements PipeTransform {
    transform(input: string | null): string | null {
        if (input === null) {
            return input;
        }
        if (input.length === 5 && input.slice(2, 3) !== '-') {
            return input.slice(0, 2) + "-" + input.slice(2);
        } else {
            return input;
        }
    }
}
